import { createSlice } from "@reduxjs/toolkit"

const adCopiesSlice = createSlice({
   name: "adCopies",
   initialState: {
      adCopies: null,
      getAdCopiesLoading: false,
      updateAdCopyLoading: false,
   },
   reducers: {
      getAdCopiesLoading: (state) => {
         state.getAdCopiesLoading = true
      },
      getAdCopiesSuccess: (state, action) => {
         state.adCopies = action.payload
         state.getAdCopiesLoading = false
      },
      getAdCopiesFailure: (state) => {
         state.getAdCopiesLoading = false
      },
      updateAdCopyLoading: (state) => {
         state.updateAdCopyLoading = true
      },
      updateAdCopySuccess: (state) => {
         state.updateAdCopyLoading = false
      },
      updateAdCopyFailure: (state) => {
         state.updateAdCopyLoading = false
      },
   },
})

export const {
   getAdCopiesLoading,
   getAdCopiesSuccess,
   getAdCopiesFailure,
   updateAdCopyLoading,
   updateAdCopySuccess,
   updateAdCopyFailure,
} = adCopiesSlice.actions

export default adCopiesSlice.reducer
